<template>
    <div>
        <div class="popup-active" v-if="showInside">
            <div class="popup-form" v-click-outside="closeEvent">
                <header class="popup-title">
                    <h2>Spara i inköpslistan</h2>
                    <svg @click="hide" class="icon popup-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </header>
                <form
                    class="add-to-grocery-list"
                    method="POST"
                    v-on:submit.prevent="submitForm"
                    v-if="!prompt"
                >
                    <label> Välj vilken lista du vill kopiera till </label>

                    <div v-bind:class="{ 'is-invalid': attemptSubmit && missingGroceryList }">
                        <div class="form-group">
                            <input
                                type="radio"
                                name="radio"
                                value="existing"
                                v-model="groceryList"
                                class="radio-input"
                                required
                            />
                            <select
                                v-model="groceryListSelect"
                                class="input-select"
                                v-bind:class="{
                                    'is-invalid':
                                        attemptSubmit && missingGroceryList && groceryList == 'existing'
                                }"
                            >
                                <option disable>Välj bland befintliga</option>
                                <option v-for="(list, index) in userGroceryLists" v-bind:value="index">
                                    {{ list.Namn }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <input
                                type="radio"
                                name="radio"
                                value="new"
                                v-model="groceryList"
                                class="radio-input"
                                required
                            />
                            <input
                                type="text"
                                v-model="groceryListText"
                                placeholder="Skapa en ny inköpslista"
                                class="form-control"
                            />
                        </div>
                    </div>
                    <div class="invalid-feedback">Välj vilken inköpslista du vill spara ingredienserna i</div>

                    <div class="form-group row">
                        <div class="col-xs-12">
                            <strong>Ingredienser</strong>
                            <p>
                                Här kan du välja vilka ingredienser ska vara med på inköpslistan, samt
                                redigera mängden ifall du behöver mer eller mindre.
                            </p>

                            <select class="servings input-select" v-model="servings" v-if="recipeServings">
                                <option v-for="n in 20" :value="n" :selected="1 == n">
                                    {{ n }} portioner
                                </option>
                            </select>

                            <table v-if="ingredientsLoaded" class="recipe-ingredients">
                                <tbody>
                                    <tr v-for="(ingredient, index) in ingredients" :key="index">
                                        <td class="quantity-col">
                                            <div class="form-group">
                                                <input
                                                    class="form-control quantity"
                                                    type="number"
                                                    step="any"
                                                    :value="getIngredientQuantity(ingredient)"
                                                    :name="'ingrediens_antal_' + index"
                                                />
                                            </div>
                                        </td>
                                        <td class="unit-col">
                                            <div class="form-group">
                                                <span class="form-control unit"
                                                    >{{ ingredient.unit }}
                                                    {{ ingredient.unitProcessedForm }}</span
                                                >
                                            </div>
                                        </td>
                                        <td class="ingredient-col">
                                            <div class="form-group">
                                                <span class="form-control">
                                                    <span class="unit-visible-xs"
                                                        >{{ ingredient.unit }}
                                                        {{ ingredient.unitProcessedForm }}</span
                                                    >
                                                    {{ ingredient.name }}
                                                </span>
                                                <input
                                                    type="hidden"
                                                    :value="ingredient.ingredient_id"
                                                    :name="'livsmedel_id_' + index"
                                                />
                                                <input
                                                    type="hidden"
                                                    :value="ingredient.unit_id"
                                                    :name="'enhet_id_' + index"
                                                />
                                                <input
                                                    type="hidden"
                                                    :value="ingredient.unit"
                                                    :name="'enhet_namn_' + index"
                                                />
                                                <input
                                                    type="hidden"
                                                    :value="ingredient.comment"
                                                    :name="'kommentar_' + index"
                                                />
                                                <input type="hidden" value="no" :name="'excluded_' + index" />
                                            </div>
                                        </td>
                                        <td class="remove-ingredient-col actions">
                                            <div class="form-group">
                                                <svg
                                                    class="icon remove-ingredient"
                                                    @click.stop="removeIngredient(index)"
                                                >
                                                    <use xlink:href="#icon-minus"></use>
                                                </svg>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- inputs  -->
                    <input type="hidden" name="Namn" :value="getGroceryListName" />
                    <input type="hidden" name="InkopslistaID" :value="getGroceryListId" />
                    <input type="hidden" name="ReceptID" :value="recipeId" />
                    <input type="hidden" name="Portioner" :value="servings" />
                    <input type="hidden" name="AntalIngredienser" :value="ingredients.length" />
                    <input type="hidden" name="kopiera_till_inkopslista" value="kopiera" />
                    <input type="hidden" name="utf-8" value="yes" />
                    <input type="hidden" name="ajax" value="yes" />

                    <button class="btn btn-primary">Spara i inköpslista</button>
                </form>
                <span v-if="prompt">{{ prompt }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

import { perServing } from '../utils/helpers.js';

export default {
    props: ['userId'],

    data() {
        return {
            state,
            showInside: false,
            groceryList: 'existing',
            groceryListSelect: 'Välj bland befintliga',
            groceryListText: '',
            servings: 1,
            userGroceryLists: [],
            baseUrl: window.appConfig.public_url,
            prompt: false,
            attemptSubmit: false,
            ingredientsLoaded: false,

            currentEvent: null
        };
    },

    mounted() {
        this.getUserGroceryList();
    },

    directives: {
        'click-outside': {
            priority: 700,

            bind: function (el, binding, vnode) {
                let self = vnode.context;

                self.currentEvent = function (event) {
                    self.closeEvent(event);
                };

                el.addEventListener('click', (event) => event.stopPropagation());

                document.body.addEventListener('click', self.currentEvent);

                $('body').addClass('lock');
            },

            unbind: function (el, binding, vnode) {
                el.removeEventListener('click', (event) => event.stopPropagation());

                document.body.removeEventListener('click', self.currentEvent);

                $('body').removeClass('lock');
            }
        }
    },

    computed: {
        groceryListForm: function () {
            return this.state.groceryListForm;
        },

        ingredients: function () {
            this.ingredientsLoaded = true;
            return perServing([...this.state.groceryListForm.ingredients]);
        },

        recipeServings: function () {
            return this.state.groceryListForm.recipeServings;
        },

        recipeId: function () {
            return this.state.groceryListForm.recipeId;
        },

        getGroceryListName: function () {
            if (this.groceryList == 'new') {
                return this.groceryListText;
            } else if (this.groceryList == 'existing' && this.userGroceryLists[this.groceryListSelect]) {
                return this.userGroceryLists[this.groceryListSelect].Namn;
            }
            return null;
        },

        getGroceryListId: function () {
            if (this.groceryList == 'existing' && this.userGroceryLists[this.groceryListSelect]) {
                return this.userGroceryLists[this.groceryListSelect].InkopslistaID;
            }
            return null;
        },

        promptSuccess: function () {
            return this.servings + ' portioner av receptet har lagts till inköpslistan';
        },

        promptError: function () {
            return 'Något gick fel! Försök igen.';
        },

        missingGroceryList: function () {
            if (this.groceryList == 'new') {
                return this.groceryListText == '';
            } else if (this.groceryList == 'existing') {
                return this.groceryListSelect == 'Välj bland befintliga';
            }
        },

        validateFields: function () {
            return !this.missingGroceryList;
        }
    },

    watch: {
        groceryListForm: {
            handler: function (form) {
                form.active ? this.show() : '';
            },
            deep: true
        },

        groceryListText: function (newVal) {
            this.groceryList = newVal ? 'new' : 'existing';
        },

        groceryListSelect: function (newVal) {
            this.groceryList = newVal ? 'existing' : 'new';
        }
    },

    methods: {
        show() {
            this.showInside = true;
        },

        hide() {
            this.showInside = false;
            this.state.groceryListForm.active = false;
            this.state.groceryListForm.recipeId = null;
            this.prompt = false;
            this.attemptSubmit = false;
        },

        getUserGroceryList() {
            axios
                .get('/api/shopping-list/user-list')
                .then((response) => {
                    this.userGroceryLists = response.data;
                })
                .catch((error) => {});
        },

        getIngredientQuantity(ingredient) {
            if (this.servings != '') {
                ingredient.updatedQuantity = this.round(ingredient.per_serving * this.servings, 2);
                return ingredient.updatedQuantity;
            }

            return ingredient.per_serving;
        },

        round(value, precision) {
            let multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        },

        removeIngredient(index) {
            this.state.groceryListForm.ingredients.splice(index, 1);
        },

        submitForm(e) {
            this.attemptSubmit = true;

            if (!this.validateFields) return;

            axios
                .post('/api/shopping-list/store', {
                    data: $(e.target).serialize(),
                    type: this.groceryList,
                    list_id: this.getGroceryListId,
                    name: this.getGroceryListName,
                    recipeId: this.recipeId,
                    servings: this.servings,
                    amount_ingredients: this.ingredients.length - 1
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.prompt = this.promptSuccess;
                    }
                })

                .catch((error) => {
                    if (error) {
                        this.error = this.promptError;
                    }
                });
        },

        closeEvent(event) {
            event.stopPropagation();
            this.hide();
        }
    }
};
</script>
